import { backgroundOrange } from '@/theme/colors'
import styled from 'styled-components'

export const MembersWrapper = styled.div`
	background-color: ${backgroundOrange};
	flex: 1;
	overflow-y: auto;
	width: 100%;
`

export const MembersContainer = styled.div`
	padding: 2rem 1.5rem;
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 600px) {
		padding: 1rem 0.875rem;
	}
`

export const MembersHeader = styled.div`
	margin-bottom: 2rem;
	text-align: center;

	@media (max-width: 600px) {
		margin-bottom: 1.25rem;
	}
`

export const MembersTitle = styled.h1`
	margin: 0;
	font-size: 2rem;
	font-weight: 700;
	color: #2c3e50;
	text-align: center;

	@media (max-width: 600px) {
		font-size: 1.5rem;
	}
`

export const MembersGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 1.5rem;

	@media (max-width: 600px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 0.875rem;
	}
`

export const MemberCard = styled.div`
	background: white;
	border-radius: 12px;
	padding: 1.5rem;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	transition: all 0.2s ease;

	&:hover {
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		transform: translateY(-2px);
	}

	@media (max-width: 600px) {
		padding: 1rem 0.75rem;
		gap: 0.625rem;
	}
`

export const MemberCardAvatar = styled.div`
	width: 80px;
	height: 80px;
	border-radius: 50%;
	background: #f3f4f6;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #6c757d;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	@media (max-width: 600px) {
		width: 64px;
		height: 64px;
	}
`

export const MemberCardName = styled.div`
	font-size: 1rem;
	font-weight: 600;
	color: #2c3e50;
	text-align: center;
`

export const LoadingState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: #6c757d;
`

export const ErrorState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: #dc3545;
`

